import { NotificationFrequency } from '../enums';
import { NotificationPreferencesDto } from '../dto';

export class NotificationPreferencesEntity {
  readonly notificationFrequency: NotificationFrequency;

  constructor(dto: NotificationPreferencesDto | null | undefined) {
    this.notificationFrequency =
      dto?.notificationFrequency ?? NotificationFrequency.IMMEDIATE;
  }
}
